import { __decorate, __metadata } from "tslib";
import { SupportedCurrencyEnum, ToBoolean } from '@goparrot/common';
import { IsArray, IsBoolean, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import { ItemOptionsMetadataSelectionTypeEnum } from '@goparrot/storeitems-sdk';
export class SearchItemResultDto {
}
__decorate([
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "guid", void 0);
__decorate([
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "title", void 0);
__decorate([
    IsArray({ always: true }),
    IsString({
        each: true,
        always: true,
    }),
    IsNotEmpty({ always: true, each: true }),
    __metadata("design:type", Array)
], SearchItemResultDto.prototype, "parentTitles", void 0);
__decorate([
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    ToBoolean(),
    __metadata("design:type", Boolean)
], SearchItemResultDto.prototype, "hasChildren", void 0);
__decorate([
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "subtitle", void 0);
__decorate([
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "internalName", void 0);
__decorate([
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], SearchItemResultDto.prototype, "price", void 0);
__decorate([
    IsOptional({ always: true }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "currency", void 0);
__decorate([
    IsOptional({ always: true }),
    IsEnum(ItemOptionsMetadataSelectionTypeEnum, { always: true }),
    __metadata("design:type", String)
], SearchItemResultDto.prototype, "selectionType", void 0);
//# sourceMappingURL=SearchItemResultDto.js.map